import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import '../css/Profile.css';
import api from '../utils/axiosConfig';

function Profile() {
  const [user, setUser] = useState(null);
  const [participants, setParticipants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const roleMap = {
    parent: 'Elternteil',
    teacher: 'Lehrkraft',
    admin: 'Administrator'
  };

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem('authToken');

      if (!token) {
        setError('Nicht authentifiziert.');
        setLoading(false);
        return;
      }

      try {
        const decoded = jwtDecode(token);
        
        // Fetch user data
        const userResponse = await api.get(`/api/users/${decoded._id}`);
        setUser(userResponse.data);

        // Fetch linked participants
        const participantsResponse = await api.get(`/api/participants`);

        // Filter by first 5 digits of user code
        const codePrefix = userResponse.data.code.slice(0, 5);
        const relatedParticipants = participantsResponse.data.filter(
          (participant) => participant.code.startsWith(codePrefix)
        );

        setParticipants(relatedParticipants);
      } catch (err) {
        console.error('Fehler beim Laden:', err);
        setError('Fehler beim Laden der Profilinformationen.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return (
    <div className="loading-container">
      <div className="spinner"></div>
      <p>Lade Profildaten...</p>
    </div>
  );

  if (error) return (
    <div className="error-container">
      <div className="error-icon">!</div>
      <p>{error}</p>
    </div>
  );

  return (
    <div className="profile-container">
      <div className="profile-header">
        <h1>Mein Profil</h1>
        <div className="profile-role-badge">
          {roleMap[user?.role] || user?.role}
        </div>
      </div>
      
      <div className="profile-content">
        {/* Personal Info Card */}
        <div className="profile-card">
          <h2 className="section-title">
            <i className="icon-user"></i> Persönliche Informationen
          </h2>
          <div className="info-grid">
            <div className="info-item">
              <span className="info-label">Name</span>
              <span className="info-value">{user?.name || '-'}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Code</span>
              <span className="info-value">{user?.code || '-'}</span>
            </div>
            <div className="info-item">
              <span className="info-label">E-Mail</span>
              <span className="info-value">{user?.email || '-'}</span>
            </div>
            {user?.institute && (
              <div className="info-item">
                <span className="info-label">Institut</span>
                <span className="info-value">{user.institute}</span>
              </div>
            )}
          </div>
        </div>

        {/* Participants Card */}
        <div className="profile-card">
          <h2 className="section-title">
            <i className="icon-group"></i> Verbundene Teilnehmer ({participants.length})
          </h2>
          {participants.length === 0 ? (
            <div className="empty-state">
              <i className="icon-info"></i>
              <p>Keine verbundene Teilnehmer gefunden.</p>
            </div>
          ) : (
            <div className="participants-container">
              {participants.map((participant) => (
                <div key={participant._id} className="participant-card">
                  <div className="participant-header">
                    <span className="participant-name">{participant.name || 'Unbenannt'}</span>
                    <span className="participant-code">{participant.code}</span>
                  </div>
                  <div className="participant-meta">
                    <span className={`status-badge ${participant.active ? 'active' : 'inactive'}`}>
                      <i className={`icon-status ${participant.active ? 'icon-active' : 'icon-inactive'}`}></i>
                      {participant.active ? 'Aktiv' : 'Inaktiv'}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Profile;